import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ObjectResolverService } from './object-resolver.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [ObjectResolverService]
})
export class ObjectResolverModule {}
